import React, {Component} from 'react';

class Article extends Component {


    render() {
        return (

            <div id="article" className="row home-block">

                <h2 className="title">Estimation</h2>
                <h3>Intervenante</h3>
                <p><a href="/#Menu">Emmanuelle Claeys</a></p>
                <h3>Description</h3>
                <p>Le but de ce <a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/Estimation_Cours_ESIEA_0.pdf"> cours</a> est
                    de comprendre les conceptes statistique qui interviennent en Machine Learning.<br/>
                    La théorie portera sur le vocabulaire probabiliste, les tests statistiques et les méthodes de
                    modèlisation<br/>
                    Les TD vous permetteront de savoir comment extraires des informations utiles d'une base de donnée,
                    utiliser un test statistique et mettre en place un modèle prédictif. <br/><br/>
                    Vous devriez, à la fin de ce cours, comprendre le travail d'un <span className="italique">data scientist</span>.
                </p>

                <h3>Cours et slides</h3>
                <li> 18.11.19. <a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/Estimation_Cours_ESIEA_1.pdf">Notions
                    générales et lois usuelles,</a>
                </li>
                <li> 19.11.19. <a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/Estimation_Cours_ESIEA_2.pdf">Construction
                    d'estimateur</a>
                </li>
                <li> 20.11.19. <a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/Estimation_Cours_ESIEA_3.pdf">Intervalle
                    de confiance</a> et <a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/Note_de%20cours_mercredi.R">notes
                    de cours en R</a>
                </li>
                <li> 20.11.19. <a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/Cours_mercredi.Rmd">A.N.O.V.A.</a>, <a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/Note_de%20cours_mercredi.R">Notes
                    de cours part 1</a>et <a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/autre_exemple_anova.R"> Notes de
                    cours part 2</a>
                </li>


                <h3>Classe inversée</h3>
                Les présentations des groupes de travail présentées le 22.11.19 sont accessibles : <a
                href="https://drive.google.com/drive/u/0/folders/1sxN51ESS7NDsLn2QO-b1aVUnG3cqrCSD">ici</a>.


                <h3>Travaux dirigés</h3>
                <li><a href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/td_0_intro_R.pdf">Prise en main
                    de R et R studio.</a>
                </li>
                <li><a href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/TD1__4A___Laval_2019_.pdf">TD
                    1 </a> <a href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/TD1_correction.R"> TD 1
                    correction</a> ,<a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/vgsales.csv"> données </a>.
                </li>
                <li><a href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/TD2__4A__laval.pdf">TD 2</a>, <a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/td2%20correction.R">TD 2
                    correction</a>,<a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/presidential_polls.csv"> données </a>.
                </li>
                <li><a href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/TD3_4056_Emmanuelle.pdf">TD
                    3</a>, <a href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/TD%203%20Correction.R">TD
                    3 correction</a>,<a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/MyData.csv"> données </a>.
                </li>

                <h3>Projet</h3>
                <li><a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/TD_bonus_shiny_4056_Emmanuelle.pdf">Projet
                    facultatif</a>
                </li>

                <h3>Examen</h3>
                <li><a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/Examen_4A_Laval_2019_partiel.pdf">Sujet</a>
                </li>

                <h3>Bibliographie</h3>
                <li>Understanding Machine Learning, From Theory to Algorithms, <em> par Shai Shalev-Shwartz et Shai
                    Ben-David</em></li>
                <li>The Elements of Statistical Learning, <em>Trevor Hastie, Robert Tibshirani et Jerome Friedman</em>
                </li>
                <li>La chaine YouTube <a href="https://www.youtube.com/channel/UCWty1tzwZW_ZNSp5GVGteaA">La statistique
                    expliquée à mon chat</a>
                </li>
                <li>Verdel Thierry propose également une retransmission de ses cours que je trouve très bien faits <a
                    href="https://www.youtube.com/playlist?list=PLuM2VYvZJBe4HrTNBtTcgOb7zOsrRf55M">ici</a>
                </li>


                <h3>Retours étudiants</h3>
                <li> Les retours des étudiants sont visibles sur <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSf_OyaBzIyea6nTK09P7tbR-uZKZECs1VCRW7XhHa3YldBH6w/viewanalytics">ce
                    lien</a>.

                </li>


            </div>

        );
    }
}

export default Article;



// WEBPACK FOOTER //
// ./src/Components/CoursEstimation2019/index.js